interface IOverlayProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  onClose?: () => void;
}

export function OverlayScreen({ isOpen, setIsOpen, onClose }: IOverlayProps) {
  const handleClick = () => {
    if (onClose) {
      onClose();
    } else {
      setIsOpen(false);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={`overlay-screen ${isOpen ? 'open' : ''}`}
      role="button"
      tabIndex={isOpen ? 0 : -1}
      aria-label="Close overlay"
    />
  );
}
